export default __webpack_public_path__ + "static/media/juego1_perder.0d5f3614.png";